import { httpRequest } from "@services/http";

export interface CreateJourneyStepPayload {
  name: string;
  parent_id?: number | null;
  is_supplemental?: boolean;
}

export class CommandCreateJourneyStep {
  async run(journeyId: number, payload: CreateJourneyStepPayload) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/journeys/${journeyId}/steps/`;
    return await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}
